export default __webpack_public_path__ + "static/hipnosis-f83d96c276ce8f1650a672bdd7328ddc.jpg";